export class ResourceItemHtmlProvider {
  constructor(filterService) {
    this.filterService = filterService;
  }

  getItemHtml(item, relatedMedia) {
    return "";
  }

  setRelatedMedia(item, relatedMedia) {
    const imageFieldName = Object.keys(window.ResourceCenterSettings.ODataSettings.ExpandedFields.Image)[0];
    let imageData;

    if (item[imageFieldName]) {
      if (Array.isArray(item[imageFieldName])){
        imageData = item[imageFieldName][0];
      }
      else {
        imageData = item[imageFieldName];
      }
    }

    let fileData;

    let englishVersion;
    if (relatedMedia && relatedMedia.length > 0) {
      englishVersion = relatedMedia.filter(media => { return media.Id === item.Id })[0]
    }

    // Fallback to english version.
    if (!imageData) {
      imageData = {};
      if (englishVersion && englishVersion[imageFieldName][0]) {
        imageData = englishVersion[imageFieldName][0];
      }
    }

    if (item.NotGated) {
      fileData = item.File[0];
      if (!fileData && (englishVersion && englishVersion.File)) {
        fileData = englishVersion.File[0];
      }
    }

    return { imageData, fileData };
  }

  getResourceUrl(contentTypeId) {
    let selectedLanguage = this.filterService.getSelectedLanguage();

    if (!selectedLanguage){
      selectedLanguage = "en";
    }

    const localizedUrl = window.localizedUrls[contentTypeId];
    let resourceUrl = "";

    if (localizedUrl) {
      resourceUrl = localizedUrl.filter(e => e.CultureName == selectedLanguage)[0].UrlName;
    }

    return resourceUrl;
  }

  encodeHtml(text){
    if(!text){
      return text;
    }
    
    var p = document.createElement("p");
    p.textContent = text;
    var result = p.innerHTML;
    return result;
  }
}
